import React, { useContext } from "react";
import "./NavBar.css";
import { useNavigate } from "react-router-dom";
import { RiLoginCircleLine, RiUser3Line } from "react-icons/ri";
import ProductContext from "../ProductContext";
const NavBar = () => {
  const navigate = useNavigate();
  ;
  const { onlineUsers } = useContext(ProductContext);
    
  const handleLogin = () => {
    navigate("/login");
  };

  const handleTest = () => {
    navigate("/test");
  };

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-left">
          <div className="navbar-connections">
            <RiUser3Line className="connections-icon" onClick={handleTest}/>
            <span>{onlineUsers}</span>
          </div>
          <h1 className="navbar-logo"></h1>
        </div>
        <div className="navbar-right">
          <button className="navbar-login-button" onClick={handleLogin}>
            <RiLoginCircleLine className="login-ico" />
          </button>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
